define('routers/_payforward',['require','views/shared/accounts/accounts','routers/accounts','routers/activities','routers/notifications','routers/causes','views/shared/error/error','models/shared/lookups/route'],function (require) {
	'use strict';

	var pf_router = Backbone.Router.extend({
		initialize: function (options) {
			options = options || {};

			this.bind('custom_route', this._pageView);

			this.ivb_message_shown = false;

			this.wellness_account_called = false;
			this.wellness_account_callbacks = [];

			// console.log('Router initialize',this);

			this.listenTo(this, 'custom_route', function (name, args) {
				pf.routeHistory.push({
					name: name,
					args: args,
					fragment: Backbone.history.fragment,
				});
			});
		},

		_pageView: function () {
			var page = Backbone.history.getFragment();

			ga('send', {
				hitType: 'pageview',
				page: page,
			});
		},

		routes: {
			// "mregister(/:IA)"               : "showMRegister",
			// "finregister"                   : "showFinRegister",
			// "cardholderagreement"           : "showCardholderAgreement",
			// "accountholderagreement"        : "showAccountholderAgreement",
			// "terms(/:HideHeader)"           : "showTerms",
			// "termsCNB"                      : "showTermsCNB",
			// "zcardterms"                    : "showZUserTerms",
			// "load"                          : "showAddMoney",
			// "invite"                        : "showInviteToPayforward",
			// "invite"                        : "showInviteView",
			// "getmobileapps"                 : "showGetMobileAppsView",
			// "wallet(/*subroute)"            : "invokeAccountsModule",
			// "activity(/*subroute)"          : "invokeActivityModule",
			// "causes(/*subroute)"            : "invokeCausesModule",
			// "messages(/*subroute)"          : "invokeMessagesModule",
			// "requests(/*subroute)"          : "invokeRequestsModule",
			// "notifications(/*subroute)"     : "invokeNotificationsModule",
			// "user(/*subroute)"              : "invokeUserModule",
			// "Search(/*subroute)"            : "invokeSearchResults",
			// "howitworks"                    : "showHowItWorks",
			// "referralterms"                 : "showReferralTerms",
			// "legal"                         : "showLegal",
			// "apigateway"                       : "invokeNewHome"

			/*
				In Question
			*/
			browserwarning: 'showBrowserWarning',
			// "privacypolicy(/:HideHeader)"   : "showPrivacyPolicy",
			// "termsM"                        : "showTermsM",
			'unsubscribe/:EG': 'showUnsubscribe',
			'eventunsubscribe/:EG': 'showEventUnsubscribe',
			'EV/:GUID/:EVCD': 'showConsumerEmailVerification',
			// "v/:version"                    :   "setContentVersion",
			linked: 'showLinkedCards',
			'Error(/:errType)': 'showError',
			'join(/:code)/:ugid': 'showAnthemAccountConverted',
			'visaenrolled/:euid': 'showVisaEnrolled',
			'visaenrolled?EUID=:euid': 'showVisaEnrolled',
			visaenrolled: 'showVisaEnrolled',

			/*
				Still Using
			*/
			'': 'showRoot',
			'register/referralcode/:Code': 'showReferralRegister',
			'register/simple?id=:id': 'showCreatePassword',
			'register/cip': 'showCip',
			'register/financial': 'showMemberApplication',
			'register/financial/cip': 'showCip',
			'register(/:IA)': 'showRegister',
			'register/address': 'showAddressConfirmation',
			'register/confirmation/address': 'showAddressConfirmation',

			'login(/:IA)': 'showLogin',
			'login/referralcode/:Code': 'showReferralLogin',

			forgotpassword: 'showForgotPassword',
			'ResetPassword/:GUID': 'showResetPasswordView',

			'merchants(/*subroute)': 'invokeMerchantsModule',
			directdeposit: 'showDirectdeposit',

			/*
				New
			*/
			home: 'showHome',
			shop: 'showShop',
			'shop/:type': 'showShopType',
			'shop/:type/:merchant': 'showShopTypeByMerchant',
			savings: 'showSavings',
			'saving(/:account_id)': 'showSaving',
			transfer: 'showTransfer',
			wallet: 'showWallet',
			'wallet/new': 'showWalletBulkReg',
			'wallet/debit': 'showWalletDebitForm',
			'transactions(/:account_id)': 'showTransactionHistory',
			profile: 'showProfile',
			password: 'showPassword',
			linkedaccounts: 'showLinkedAccounts',
			reservations: 'showReservations',
			'reservation(/:reservation_guid)': 'showReservation',
			contact: 'showContact',
			'delete-account': 'showDeleteAccount',
			invite: 'showInvite',
			wellness: 'showWellness',
			enterprise: 'showEnterprise',
			notifications: 'showNotificationsDashboard',
			loyalty: 'showConsumerLanding',
			'how-to': 'showHowTos',

			/*
				Legal
			*/
			terms: 'showTerms',
			'terms-of-service': 'showTermOfService',
			incentives: 'showIncentives',
			'cardholder-agreement': 'showCardholder',
			'accountholder-agreement': 'showAccountholder',
			'privacy-policy': 'showPrivacy',
			'prepaid-policy': 'showPrepaid',
			fees: 'showFeeAgreement',
			'approved-items': 'showApprovedItems',

			linkcard: 'showLinkCardView',

			'*notDefined': 'notDefined',
		},
		//_routeToRegExp: function(route) {
		//    var namedParam = /:\w+/g;
		//    var splatParam = /\*\w+/g;
		//    var escapeRegExp = /[-[\]{}()+?.,\\^$|#\s]/g;

		//    route = route.replace(escapeRegExp, '\\$&')
		//                 .replace(namedParam, '([^\/]+\/?)')
		//                 .replace(splatParam, '(.*?)');
		//    return new RegExp('^' + route + '$', 'i');
		//},

		before: function (route, params) {
			if (route) {
				if (pf.session.get('auth')) {
					var routeName = route.substring(0, route.indexOf('('));
					pf.globalEvents.trigger('Navigation:Changed', routeName);
				}
			}

			switch (route) {
				case 'directdeposit':
					$('#header-container').remove();
					$('#environment').remove();
					$('#footer-container').remove();
					break;
				case ('register/referralcode/:Code',
				'register(/:IA)',
				'mregister(/:IA)',
				'EV/:GUID/:EVCD',
				'unsubscribe/:EG',
				'eventunsubscribe/:EG',
				'ResetPassword/:GUID'):
					if (pf.session.get('auth')) {
						var that = this;
						pf.session.destroy({
							async: false,
							success: function (model, resp) {
								model.clear();
								model.id = null;
								pf.session.cleanup();
								store.removeStoreItem();
								pf.session.getAuth();
							},
							error: function (model, resp) {
								pf.navigate('');
							},
						});
					}

					$('#header-container').removeClass('hidden');
					$('#environment').removeClass('hidden');
					$('#footer-container').removeClass('hidden');

					break;
				default:
					$('#header-container').removeClass('hidden');
					$('#environment').removeClass('hidden');
					$('#footer-container').removeClass('hidden');
					break;
			}

			// console.log('before routing', route, params, pf.getFeature('wellness'));

			if (
				_.isBoolean(pf.isValidBrowser) &&
				pf.isValidBrowser === false &&
				this.ivb_message_shown == false
			) {
				this.showUpgradeBrowserView();
			}
		},

		after: function (route, params) {
			if (route) {
			}
			// console.log('history', Backbone.history);
		},

		showUpgradeBrowserView: function () {
			var that = this;

			require(['views/shared/modal/modal_modern'], function (ModalComponent) {
				require(['views/shared/alerts/alert'], function (AlertModalComponent) {
					that.alert_modal = new AlertModalComponent({
						// General
						calling_view: that,
						alert_type: 2,
						// Transactional
						is_transaction: false,
						// Content
						alert_header: '',
						alert_content_header: pf.getContent(
							'global.content.outdated_browser.header'
						),
						alert_message_icon: 'global.icons.yield',
						alert_message: pf.getContent(
							'global.content.outdated_browser.message'
						),
						// Default
						btn_label: 'Upgrade Browser',
						btn_callback: that.showUpgradeBrowser,
						btn_retry_callback: that.showUpgradeBrowser,
						// Confirm
						btn_confirm: false,
						// Cancel
						btn_cancel: true,
						btn_cancel_label: 'Cancel',
						btn_cancel_callback: that.cancelUpgradeBrowser,
						// Success
						btn_success: false,
						// Error
						btn_error: false,
					});

					that.modal = new ModalComponent({
						show: true,
						content: that.alert_modal.$el.html(),
						calling_view: that.alert_modal,
					});

					that.ivb_message_shown = true;
				});
			});
		},

		showUpgradeBrowser: function () {
			window.open('https://browsehappy.com/');
			// temporary fix for IE11 and context until we can debug locally
			$('#pf-modal-modern').fadeOut(function () {
				$('#pf-modal-modern').remove();
			});
		},

		cancelUpgradeBrowser: function () {
			$('#pf-modal-modern').fadeOut(function () {
				$('#pf-modal-modern').remove();
			});
		},

		setupEnvironment: function (callback) {
			this.site_version = pf.getContent('version.id');

			// if(pf.session.get('auth')){
			//     this.loadAccounts();
			// }

			// this.appRoute('ping/:query/p:num', 'setupEnvironment');

			require(['views/shared/header/header'], function (HeaderView) {
				var header_view = new HeaderView();
				$('#header-container').html(header_view.el);
				pf.header = header_view;
			});

			require(['views/shared/footer/footer'], function (FooterView) {
				var footer_view = new FooterView();
				$('#footer-container').html(footer_view.el);
			});

			pf.session.on('change:auth', function (model, collection, options) {
				// console.log('Auth Changed PF Controller:', pf.session.get('auth'), model, collection, options);

				if (!pf.session.get('auth')) {
					// that.showRoot();
				}
			});
		},

		register: function (route, name, path) {
			var self = this;
			// console.log('Router register',name);

			this.route(route, name, function () {
				var args = arguments;

				// console.log('Route callback function',args);

				// require([path], function (module) {
				//     var options = null;
				//     var parameters = route.match(/[:\*]\w+/g);

				//     // Map the route parameters to options for the View.
				//     if(parameters){
				//         options = {};
				//         _.each(parameters, function(name, index) {
				//             options[name.substring(1)] = args[index];
				//         });
				//     }

				//     var page = Vm.create(self.appView, name, module, options);
				//     page.render();
				// });
			});
		},

		showLinkCardView: function () {
			pf.require(
				'views/accounts/linknewcard/linknewcard',
				null,
				null,
				true,
				function () {
					require(['views/accounts/linknewcard/linknewcard'], function (view) {
						pf.show(new view({ elementName: '#mainRegion' }));
					});
				}
			);
		},

		/*
			Redesign Route Functions
		*/

		loadAccounts: function (callback, load_fresh) {
			var that = this,
				AccountsController = require('views/shared/accounts/accounts');

			pf.accounts = pf.accounts ? pf.accounts : new AccountsController();
			pf.accounts.get(callback);
		},

		loadWellnessAccount: function (callback) {
			if (!this.wellness_account_called) {
				var that = this,
					account_url = pf.url + '/Wellness/Account';

				this.wellness_account_called = true;

				this.wellness_account_callbacks.push(callback);

				$.ajax({
					type: 'GET',
					url: account_url,
					contentType: 'application/json',
					success: function (response, status, options) {
						// console.log('getWellnessAccounts account_url success',response, status, options);

						pf.wellness_account = response;

						if (that.wellness_account_callbacks.length > 1) {
							that.wellness_account_callbacks.forEach(function (callback_func) {
								if (_.isFunction(callback_func)) {
									callback_func();
								}
							});
						} else {
							if (_.isFunction(callback)) {
								callback();
							}
						}
					},
					error: function (response, status, options) {
						// console.log('getWellnessAccounts account_url error',response, status, options);

						if (status.status == 412) {
							saveCipTriggerRoute('wellness');

							pf.navigate('register/financial/cip', { trigger: true });
						}
					},
				});
			} else {
				this.wellness_account_callbacks.push(callback);
			}
		},

		showHome: function (options) {
			var that = this,
				is_shop_view = options ? options.is_shop_view : false;

			if (pf.session.get('auth') || is_shop_view) {
				// Look at the content routes to determine root/home view
				// pf.require('views/home/home', null, null, true, function(){
				//     require(['views/home/home'], function(view){
				//         pf.show(new view({ elementName: '#mainRegion', options: options }));
				//         // NOTE: Consider loading or re-loading data here
				//     });
				// });

				// Temporary workaround
				var wellness = pf.getFeature(enums.features.wellness);

				if (wellness) {
					if (!pf.wellness_account || _.isNull(pf.wellness_account)) {
						this.loadWellnessAccount(function () {
							that.showWellness();
						});
					} else {
						this.showWellness();
					}
				} else {
					// Look at the content routes to determine root/home view
					pf.require('views/home/home', null, null, true, function () {
						require(['views/home/home'], function (view) {
							pf.show(
								new view({ elementName: '#mainRegion', options: options })
							);
							// NOTE: Consider loading or re-loading data here
						});
					});
				}
			} else {
				this.showRoot();
			}
		},

		showShop: function () {
			pf.navigate('home');
			// this.showHome({ shop: true, focused: true });
		},

		showShopType: function (type) {
			if (type == 'nearby') {
				var shop_type = enums.merchantLocationTypes.Store;
			} else if (type == 'online') {
				var shop_type = enums.merchantLocationTypes.Online;
			} else if (type == 'travel') {
				var shop_type = enums.merchantLocationTypes.Travel;
			} else {
				var shop_type = enums.merchantLocationTypes.Store;
			}

			if (pf.session.get('auth')) {
				pf.navigate('home');
				// this.showHome({ shop: true, focused: true, type: shop_type });
			} else {
				this.showHome();
			}
		},

		showShopTypeByMerchant: function (type, merchant) {
			pf.navigate('home');
			return;
			if (type == 'nearby') {
				var shop_type = enums.merchantLocationTypes.Store;
			} else if (type == 'online') {
				var shop_type = enums.merchantLocationTypes.Online;
			} else {
				var shop_type = enums.merchantLocationTypes.Store;
			}

			this.showHome({
				shop: true,
				focused: true,
				type: shop_type,
				merchant_guid: merchant,
				is_shop_view: true,
			});
		},

		showSavings: function () {
			pf.require('views/savings/savings', null, null, true, function () {
				require(['views/savings/savings'], function (view) {
					pf.show(
						new view({
							elementName: '#mainRegion',
							options: { view: 'savings' },
						})
					);
				});
			});
		},

		showSaving: function (account_id) {
			pf.require('views/savings/saving_detail', null, null, true, function () {
				require(['views/savings/saving_detail'], function (view) {
					pf.show(
						new view({ elementName: '#mainRegion', account_id: account_id })
					);
				});
			});
		},

		showTransfer: function () {
			if (this.site_version === enums.siteVersion.payforward) {
				pf.require('views/transfer/transfer', null, null, true, function () {
					require(['views/transfer/transfer'], function (view) {
						pf.show(new view({ elementName: '#mainRegion' }));
					});
				});
			} else {
				pf.navigate('home');
			}
		},

		showWallet: function (bulk_reg_transfer, show_debit_form) {
			pf.require('views/wallet/wallet', null, null, true, function () {
				require(['views/wallet/wallet'], function (view) {
					pf.show(
						new view({
							elementName: '#mainRegion',
							bulk_reg_transfer: bulk_reg_transfer,
							show_debit_form: show_debit_form,
						})
					);
				});
			});
		},

		showWalletBulkReg: function () {
			this.showWallet(true);
		},

		showWalletDebitForm: function () {
			this.showWallet(false, true);
		},

		showTransactionHistory: function (account_id) {
			pf.require(
				'views/transactions/transactions',
				null,
				null,
				true,
				function () {
					require(['views/transactions/transactions'], function (view) {
						pf.show(
							new view({ elementName: '#mainRegion', account_id: account_id })
						);
					});
				}
			);
		},

		showProfile: function (options) {
			if (!options) {
				var options = { view: 'profile' };
			}
			pf.require('views/profile/profile', null, null, true, function () {
				require(['views/profile/profile'], function (view) {
					pf.show(new view({ elementName: '#mainRegion', options: options }));
				});
			});
		},

		showPassword: function () {
			this.showProfile({ view: 'password' });
		},

		showLinkedAccounts: function () {
			this.showProfile({ view: 'linkedaccounts' });
		},

		showNotificationsDashboard: function () {
			this.showProfile({ view: 'notifications' });
		},

		showReservations: function () {
			this.showProfile({ view: 'reservations' });
		},

		showReservation: function (reservation_guid) {
			pf.require(
				'views/reservations/reservation_details',
				null,
				null,
				true,
				function () {
					require(['views/reservations/reservation_details'], function (view) {
						pf.show(
							new view({
								elementName: '#mainRegion',
								reservation_guid: reservation_guid,
							})
						);
					});
				}
			);
		},

		showContact: function () {
			this.showProfile({ view: 'contact' });
		},

		showDeleteAccount: function () {
			this.showProfile({ view: 'delete-account' });
		},

		showInvite: function () {
			this.showProfile({ view: 'invite' });
		},

		showTerms: function () {
			this.showProfile({ view: 'terms' });
		},

		showHowTos: function () {
			this.showProfile({ view: 'how-to' });
		},

		showTermsPDF: function (options) {
			pf.require('views/terms/terms_reroute', null, null, true, function () {
				require([
					'views/terms/terms_reroute',
				], function (TermsReRouteComponent) {
					var terms_reroute = new TermsReRouteComponent({ options: options });
				});
			});
		},

		showFeeAgreement: function () {
			this.showTermsPDF({ view: 'fees' });
		},

		showApprovedItems: function () {
			this.showTermsPDF({ view: 'approved_items' });
		},

		showTermOfService: function () {
			this.showTermsPDF({ view: 'terms-of-service' });
		},

		showIncentives: function () {
			this.showTermsPDF({ view: 'incentives' });
		},

		showCardholder: function () {
			this.showTermsPDF({ view: 'cardholder-agreement' });
		},

		showAccountholder: function () {
			this.showTermsPDF({ view: 'accountholder-agreement' });
		},

		showPrivacy: function () {
			this.showTermsPDF({ view: 'privacy-policy' });
		},

		showPrepaid: function () {
			this.showTermsPDF({ view: 'prepaid-policy' });
		},

		showWellness: function () {
			var status_id = pf.session.get('UserStatusId');

			if (status_id != undefined) {
				if (
					(status_id & enums.userStatusId.accepted_cardholder_agreement) !=
					enums.userStatusId.accepted_cardholder_agreement
				) {
					this.showAddressConfirmation();

					return false;
				}
			}

			pf.require('views/wellness/wellness', null, null, true, function () {
				require(['views/wellness/wellness'], function (view) {
					pf.show(new view({ elementName: '#mainRegion' }));
				});
			});
		},

		/*
			End Redesign Route Functions
		*/

		/*
			Possibly Deprecated
		*/

		showDirectdeposit: function () {
			pf.require(
				'views/user/directdeposit/directdeposit',
				null,
				null,
				true,
				function () {
					require(['views/user/directdeposit/directdeposit'], function (
						DirectDepositView
					) {
						pf.show(new DirectDepositView({ elementName: '#contentRegion' }));
					});
				}
			);
		},

		showBrowserWarning: function () {
			pf.require(
				'views/shared/browserwarning/browserwarning',
				null,
				null,
				true,
				function () {
					require(['views/shared/browserwarning/browserwarning'], function (
						view
					) {
						pf.show(new view(), '#header-container');
					});
				}
			);
		},

		showLogin: function (IA) {
			// console.log('showLogin',!isInApp());

			if (!isInApp()) {
				if (pf.session.get('auth')) {
					pf.navigate('');
				} else {
					var goHome = false;
					var path = pf.getCurrentRoute();

					if (path == '') {
						goHome = true;
					}

					pf.viewLogin(goHome, null, null, { IA: IA });
				}
			}
		},

		showAddressConfirmation: function () {
			pf.require(
				'views/register/address_confirmation',
				null,
				null,
				true,
				function () {
					require(['views/register/address_confirmation'], function (Register) {
						pf.show(new Register({ elementName: '#mainRegion' }));
					});
				}
			);

			// if(pf.session.get('auth')){
			//     pf.navigate('');
			// } else {
			//     pf.require('views/register/address_confirmation', null, null, true, function(){
			//         require(['views/register/address_confirmation'], function(Register){
			//             pf.show(new Register({ elementName: '#mainRegion' }));
			//         });
			//     });
			// }
		},

		showRegister: function (IA) {
			if (pf.session.get('auth')) {
				pf.navigate('');
			} else {
				pf.require('views/register/register', null, null, true, function () {
					require(['views/register/register'], function (Register) {
						pf.show(new Register({ elementName: '#mainRegion', IA: IA }));
					});
				});

				// pf.require("views/user/register/register", null, null, true, function(){
				//     require(["views/user/register/register"], function(view){
				//         pf.show(new view({ IA: IA, elementName: "#mainRegion" }));
				//     });
				// });
			}
		},

		showMRegister: function (IA) {
			removeToken();
			pf.session.inApp = true;

			hideHeader();
			this.showRegister(IA);
		},

		showFinRegister: function () {
			//pf.require("views/user/register/financial/memberapplication", null, null, true, function(){
			//    require(["views/user/register/financial/memberapplication"], function(view){
			//        pf.show(new view({ elementName: "#mainRegion" }));
			//    });
			//});

			pf.require(
				'views/user/register/financial/productselection',
				null,
				null,
				true,
				function () {
					require(['views/user/register/financial/productselection'], function (
						productselectionView
					) {
						pf.show(new productselectionView({ elementName: '#mainRegion' }));
					});
				}
			);
		},

		showReferralRegister: function (Code) {
			if (pf.session.get('auth')) {
				pf.navigate('');
			} else {
				store.setStoreItem(enums.modelsEnum.ReferralCode, { Data: Code });

				pf.require(
					'views/user/register/register',
					null,
					null,
					true,
					function () {
						require(['views/user/register/register'], function (view) {
							pf.show(new view({ ReferralCode: Code }), '#mainRegion');
						});
					}
				);
			}
		},

		showMemberApplication: function (options) {
			var product = enums.cardTypes.VirtualCard;

			// pf.require("views/user/register/financial/memberapplication", null, null, true, function(){
			//     require(["views/user/register/financial/memberapplication"], function(FinancialRegView){
			//         pf.show(new FinancialRegView({ elementName: "#mainRegion", product: product, isBcbsla: false, isTrigger: true }));
			//     });
			// });

			if (_.isObject(options) && options.isTrigger) {
				this.showCip();
			} else {
				pf.require('views/register/financial', null, null, true, function () {
					require(['views/register/financial'], function (FinancialRegView) {
						pf.show(
							new FinancialRegView({
								elementName: '#mainRegion',
								product: product,
								isBcbsla: false,
								isTrigger: false,
							})
						);
					});
				});
			}
		},

		showCreatePassword: function (id) {
			var that = this;

			getFeatures(id, function (features) {
				pf.features = features || [];

				pf.require(
					'views/register/bulk/register',
					null,
					null,
					true,
					function () {
						require(['views/register/bulk/register'], function (Register) {
							pf.show(
								new Register({
									elementName: '#mainRegion',
									registration_id: id,
								})
							);

							if (that.site_version == enums.siteVersion.anthem) {
								that.addAnthemClass();
							}
						});
					}
				);
			});

			// pf.require("views/root/root", null, null, true, function(){
			//     require(["views/root/root"], function(view){
			//         pf.show(new view({ elementName: "#mainRegion", RegistrationId: null }));
			//         if(that.site_version == enums.siteVersion.anthem){
			//             that.addAnthemClass();
			//         }
			//     });
			// });

			// pf.require("views/root/root", null, null, true, function(){
			//     require(["views/root/root"], function(view){
			//         pf.show(new view({ elementName: "#mainRegion", RegistrationId: id }));
			//         if(that.site_version == enums.siteVersion.anthem){
			//             that.addAnthemClass();
			//         }
			//     });
			// });
		},

		showCip: function (id) {
			var product = enums.cardTypes.VirtualCard;

			// pf.require("views/user/register/financial/memberapplication", null, null, true, function(){
			//     require(["views/user/register/financial/memberapplication"], function(FinancialRegView){
			//         pf.show(new FinancialRegView({ elementName: "#mainRegion", product: product, isBcbsla: false }));
			//     });
			// });

			pf.require('views/register/financial', null, null, true, function () {
				require(['views/register/financial'], function (FinancialRegView) {
					pf.show(
						new FinancialRegView({
							elementName: '#mainRegion',
							product: product,
							isBcbsla: false,
							isTrigger: true,
						})
					);
				});
			});
		},

		showReferralLogin: function (Code) {
			if (!isInApp()) {
				if (pf.session.get('auth')) {
					pf.navigate('');
				} else {
					var goHome = false;
					var path = pf.getCurrentRoute();
					if (path == '') {
						goHome = true;
					}
					pf.viewLogin(goHome, null, null, { ReferralCode: Code });
				}
			}
		},

		showForgotPassword: function (options) {
			//pf.popupboxclose();
			//var ForgotPasswordView = require("views/user/forgotpassword/forgotpassword");
			//pf.show(new ForgotPasswordView(options), "#mainRegion");

			pf.require(
				'views/user/forgotpassword/forgotpassword',
				null,
				null,
				true,
				function () {
					require(['views/user/forgotpassword/forgotpassword'], function (
						view
					) {
						pf.show(new view(options), '#mainRegion');
					});
				}
			);
		},

		showResetPasswordView: function (GUID) {
			//var ResetPasswordView = require("views/user/forgotpassword/resetpassword/resetpassword");
			//pf.show(new ResetPasswordView({ GUID: GUID }), "#mainRegion");

			pf.require(
				'views/user/forgotpassword/resetpassword/resethome',
				null,
				null,
				true,
				function () {
					require([
						'views/user/forgotpassword/resetpassword/resethome',
					], function (view) {
						pf.show(new view({ GUID: GUID, elementName: '#mainRegion' }));
					});
				}
			);
		},

		signOut: function () {
			this.cleanup();
			pf.session.logout();
		},

		showRoot: function () {
			var that = this,
				wellness = pf.getFeature(enums.features.wellness);

			if (pf.session.get('auth')) {
				if (wellness) {
					// Check User Status, if status 1: Registration and 3: Address Confirmation
					this.showWellness();
				} else {
					this.showHome();
				}
			} else {
				if (this.site_version == enums.siteVersion.payforward) {
					pf.require('views/root/root', null, null, true, function () {
						require(['views/root/root'], function (view) {
							pf.show(new view({ elementName: '#mainRegion' }));
							if (that.site_version == enums.siteVersion.anthem) {
								that.addAnthemClass();
							}
						});
					});
				} else {
					this.showConsumerLanding();
				}
			}

			// Temporary solution to header not showing after login/register views
			if (!$('#header-container').is(':visible')) {
				$('#header-container').show();
			}
		},

		showConsumerLanding: function () {
			pf.require('views/root/consumer/landing', null, null, true, function () {
				require(['views/root/consumer/landing'], function (view) {
					pf.show(new view({ elementName: '#mainRegion' }));
				});
			});
		},

		showEnterprise: function () {
			if (pf.session.get('auth')) {
				this.showHome();
			} else {
				pf.require(
					'views/root/enterprise/enterprise',
					null,
					null,
					true,
					function () {
						require(['views/root/enterprise/enterprise'], function (view) {
							pf.show(new view({ elementName: '#mainRegion' }));
						});
					}
				);
			}

			// Temporary solution to header not showing after login/register views
			if (!$('#header-container').is(':visible')) {
				$('#header-container').show();
			}
		},

		invokeAccountsModule: function (subroute) {
			pf.Routers = pf.Routers || {};

			// console.log('invokeAccountsModule',subroute);
			if (!pf.Routers.Accounts) {
				var AccountsRouter = require('routers/accounts');
				pf.Routers.Accounts = new AccountsRouter('wallet');
			}
		},

		showAddMoney: function () {
			pf.navigate('wallet/addmoney');
		},

		showInviteToPayforward: function () {
			pf.require('views/invite/invitelanding', null, null, true, function () {
				require(['views/invite/invitelanding'], function (view) {
					pf.show(new view({ elementName: '#mainRegion' }));
				});
			});
		},

		showInviteView: function () {
			pf.require('views/invite/invite', null, null, true, function () {
				require(['views/invite/invite'], function (view) {
					pf.show(new view({ elementName: '#mainRegion' }));
				});
			});
		},

		// invokeNewHome: function(subroute){
		//     console.log('??');
		//     pf.require("views/newhome/newhomewrapper", null, null, true, function(){
		//         require(["views/newhome/newhomewrapper"], function(view){
		//             pf.show(new view({ elementName: "#mainRegion" }));
		//         });
		//     });
		// },

		invokeActivityModule: function (subroute) {
			pf.Routers = pf.Routers || {};

			if (!pf.Routers.Activity) {
				var ActivityRouter = require('routers/activities');
				pf.Routers.Activity = new ActivityRouter('activity');
			}
		},

		invokeNotificationsModule: function (subroute) {
			pf.Routers = pf.Routers || {};

			if (!pf.Routers.Notifications) {
				var NotificationsRouter = require('routers/notifications');
				pf.Routers.Notifications = new NotificationsRouter('notifications');
			}
		},

		invokeCausesModule: function (subroute) {
			pf.Routers = pf.Routers || {};

			if (!pf.Routers.Causes) {
				var CausesRouter = require('routers/causes');
				pf.Routers.Causes = new CausesRouter('causes', {
					createTrailingSlashRoutes: false,
				});
			}
		},

		invokeMerchantsModule: function (subroute) {
			console.log(
				'%cSTOP LOAD - invokeMerchantsModule',
				'color: rebeccapurple'
			);
			pf.navigate('home');
			// pf.Routers = pf.Routers || {};

			// if (!pf.Routers.Merchants) {
			// 	var MerchantsRouter = require('routers/merchants');
			// 	pf.Routers.Merchants = new MerchantsRouter('merchants');
			// }
		},

		// invokeMessagesModule: function(subroute){
		//     pf.Routers = pf.Routers || {};

		//     if (!pf.Routers.Messages) {
		//         var MessagesRouter = require("routers/messages");
		//         pf.Routers.Messages = new MessagesRouter("messages");
		//     }
		// },

		invokeRequestsModule: function (subroute) {
			pf.Routers = pf.Routers || {};

			if (!pf.Routers.Requests) {
			}
		},

		invokeUserModule: function (subroute) {
			pf.Routers = pf.Routers || {};

			// if (!pf.Routers.User) {
			//     var UserRouter = require("routers/user");
			//     pf.Routers.User = new UserRouter("user");
			// }
		},

		invokeSearchResults: function (subroute) {
			pf.Routers = pf.Routers || {};

			// if (!pf.Routers.Search) {
			//     var SearchRouter = require("routers/search");
			//     pf.Routers.Search = new SearchRouter("Search");
			// }
		},

		showConsumerEmailVerification: function (GUID, EVCD) {
			//var emailVerificationView = require("views/shared/home/emailverification/emailverification");

			var that = this;
			//var homeView = require("views/root/root");
			////pf.displayOnePanel(homeView, { GUID: GUID, VerificationCode: EVCD });
			//pf.show(new homeView({ GUID: GUID, VerificationCode: EVCD }), "#mainRegion");

			pf.require('views/root/root', null, null, true, function () {
				require(['views/root/root'], function (homeView) {
					pf.show(
						new homeView({
							GUID: GUID,
							VerificationCode: EVCD,
							elementName: '#mainRegion',
						})
					);
				});
			});
		},

		// showPrivacyPolicy: function(HideHeader){
		//     var that = this;
		//     if (HideHeader == 1) hideHeader();
		//     pf.require("views/shared/privacypolicy/privacypolicy", null, null, true, function(){
		//         require(["views/shared/privacypolicy/privacypolicy"], function(PrivacyPolicyView){
		//             var template = require("text!views/user/privacypolicy/privacypolicy.html");
		//             pf.show(new PrivacyPolicyView({ Template: template }), "#mainRegion");
		//             // Temporary fix to Anthem header/styles
		//             if(that.site_version == enums.siteVersion.anthem && !pf.session.get("auth")){
		//                 that.addAnthemClass();
		//             }
		//         });
		//     });
		// },
		// showTerms: function(HideHeader){
		//     var that = this;
		//     if (HideHeader == 1) hideHeader();
		//     pf.require("views/shared/terms/terms", null, null, true, function(){
		//         require(["views/shared/terms/terms"], function(TermsView){
		//             var template = require("text!views/user/terms/terms.html");
		//             pf.show(new TermsView({ Template: template }), "#mainRegion");
		//             // Temporary fix to Anthem header/styles
		//             if(that.site_version == enums.siteVersion.anthem && !pf.session.get("auth")){
		//                 that.addAnthemClass();
		//             }
		//         });
		//     });
		// },
		// showTermsCNB: function(){
		//     var that = this;
		//     //var TermsCNBView = require("views/shared/terms/terms");
		//     //var template = require("text!views/user/terms/termsCNB.html");
		//     //pf.show(new TermsCNBView({ Template: template }), "#mainRegion");

		//     pf.require("views/shared/terms/terms", null, null, true, function(){
		//         require(["views/shared/terms/terms"], function(TermsCNBView){
		//             var template = require("text!views/user/terms/termsCNB.html");
		//             pf.show(new TermsCNBView({ Template: template }), "#mainRegion");
		//             // Temporary fix to Anthem header/styles
		//             if(that.site_version == enums.siteVersion.anthem && !pf.session.get("auth")){
		//                 that.addAnthemClass();
		//             }
		//         });
		//     });
		// },
		// showTermsM: function(){
		//     pf.require("views/shared/terms/mobile", null, null, true, function(){
		//         require(["views/shared/terms/mobile"], function(TermsMView){
		//             var template = require("text!views/user/terms/mobile.html");
		//             pf.show(new TermsMView({ Template: template }), "#mainRegion");
		//         });
		//     });
		// },

		showCardholderAgreement: function () {
			var that = this;
			pf.require(
				'views/user/cardholderagreement/cardholderagreement',
				null,
				null,
				true,
				function () {
					require([
						'views/user/cardholderagreement/cardholderagreement',
					], function (CardHolderAgreementView) {
						pf.show(new CardHolderAgreementView(), '#mainRegion');
						// Temporary fix to Anthem header/styles
						if (
							that.site_version == enums.siteVersion.anthem &&
							!pf.session.get('auth')
						) {
							that.addAnthemClass();
						}
					});
				}
			);
		},

		showAccountholderAgreement: function () {
			var that = this;
			pf.require(
				'views/user/accountholderagreement/acocuntholderagreement',
				null,
				null,
				true,
				function () {
					require([
						'views/user/accountholderagreement/accountholderagreement',
					], function (AccountHolderAgreementView) {
						pf.show(new AccountHolderAgreementView(), '#mainRegion');
						// Temporary fix to Anthem header/styles
						if (
							that.site_version == enums.siteVersion.anthem &&
							!pf.session.get('auth')
						) {
							that.addAnthemClass();
						}
					});
				}
			);
		},

		showError: function (errType) {
			if (errType == pf.enums.errorEnum.NotAuthorized || true) {
				var errorView = require('views/shared/error/error');
				pf.show(new errorView(), '#mainRegion');
			}
		},

		showUnsubscribe: function (UG) {
			//var unsubscribeView = require("views/shared/unsubscribe/unsubscribe");
			//pf.show(new unsubscribeView({ UG: UG }), "#mainRegion");

			pf.require(
				'views/shared/unsubscribe/unsubscribe',
				null,
				null,
				true,
				function () {
					require(['views/shared/unsubscribe/unsubscribe'], function (
						unsubscribeView
					) {
						pf.show(new unsubscribeView({ UG: UG }), '#mainRegion');
					});
				}
			);
		},

		showEventUnsubscribe: function (UG) {
			//var unsubscribeView = require("views/shared/unsubscribe/unsubscribe");
			//pf.show(new unsubscribeView({ UG: UG }), "#mainRegion");

			pf.require(
				'views/shared/unsubscribe/unsubscribe',
				null,
				null,
				true,
				function () {
					require(['views/shared/unsubscribe/unsubscribe'], function (
						unsubscribeView
					) {
						pf.show(
							new unsubscribeView({ UG: UG, Event: true }),
							'#mainRegion'
						);
					});
				}
			);
		},

		showHowItWorks: function () {
			// pf.globalEvents.trigger("Navigation:Changed", "howitworks");
			// pf.require("views/shared/howitworks/howitworks", null, null, true, function(){
			//     require(["views/shared/howitworks/howitworks"], function(howitworksView){
			//         pf.show(new howitworksView(), "#mainRegion");
			//     });
			// });
		},

		showGetMobileAppsView: function () {
			pf.require(
				'views/shared/getmobileapps/getmobileapps',
				null,
				null,
				true,
				function () {
					require(['views/shared/getmobileapps/getmobileapps'], function (
						view
					) {
						pf.show(new view(), '#mainRegion');
					});
				}
			);
		},

		showReferralTerms: function () {
			var that = this;
			// pf.require("views/user/referralterms/referralterms", null, null, true, function(){
			//     require(["views/user/referralterms/referralterms"], function(view){
			//         pf.show(new view({ elementName: "#mainRegion" }));
			//         // Temporary fix to Anthem header/styles
			//         if(that.site_version == enums.siteVersion.anthem && !pf.session.get("auth")){
			//             that.addAnthemClass();
			//         }
			//     });
			// });
		},

		showLinkedCards: function () {
			if (pf.session.get('auth')) {
				this.showHome();
			} else {
				pf.require(
					'views/linkedcards/linkedcards',
					null,
					null,
					true,
					function () {
						require(['views/linkedcards/linkedcards'], function (view) {
							pf.show(new view(), '#linkedcards');
						});
					}
				);
			}
		},

		showVisaEnrolled: function (euid) {
			if (euid) {
				this.euid = euid;
			} else {
				if (this.euid) euid = this.euid;
			}

			$.ajax({
				type: 'GET',
				url: pf.lookupsURL + '/LinkedCardOrigin?euid=' + euid,
				data: null,
				async: false,
				contentType: 'application/json; charset=utf-8',
				traditional: true,
				success: function (response) {
					if (response && !isEmpty(response.originURL)) {
						window.location.href =
							response.originURL + '/#visaenrolled?EUID=' + euid;
					} else {
						pf.require(
							'views/user/register/financial/linkedcardsuccess',
							null,
							null,
							true,
							function () {
								require([
									'views/user/register/financial/linkedcardsuccess',
								], function (view) {
									pf.show(new view({ EUID: euid }), '#mainRegion');
								});
							}
						);
					}
				},
				error: function (response) {},
			});
		},

		showZUserTerms: function (route) {
			// pf.require("views/user/register/zcard/zcardcreateaccount", null, null, true, function(){
			//     require(["views/user/register/zcard/zcardcreateaccount"], function(view){
			//         pf.show(new view({ route: route }), "#mainRegion");
			//     });
			// });

			$('#header-container').removeClass('hidden');
			$('#environment').removeClass('hidden');
			$('#footer-container').removeClass('hidden');
		},

		showLegal: function () {
			//window.location = "//cdn.payforward.com/docs/legal.html";
			// var url = pf.getContent('global.url.legal_disclosures');
			// window.location = url;
		},

		showAnthemAccountConverted: function (code, ugid) {
			pf.require(
				'views/shared/anthemaccountconverted/anthemaccountconverted',
				null,
				null,
				true,
				function () {
					require([
						'views/shared/anthemaccountconverted/anthemaccountconverted',
					], function (view) {
						pf.show(new view({ code: code, ugid: ugid }), '#mainRegion');
					});
				}
			);
		},

		//setContentVersion: function(version) {
		//    pf.session.contentVersion = version;
		//    this.showRoot();
		//},
		// showForsythe: function(){
		//     pf.require("views/root/partner_root/partner_root", null, null, true, function(){
		//         require(["views/root/partner_root/partner_root"], function(view){
		//             pf.show(new view({ elementName: "#mainRegion" }));
		//         });
		//     });

		// pf.require("views/shared/blankcanvas/blankcanvas", null, null, true, function(){
		//     require(["views/shared/blankcanvas/blankcanvas"], function(view){
		//         pf.show(new view({ elementName: "#mainRegion" }));
		//     });
		// });
		// },

		addAnthemClass: function () {
			// $('html').removeClass('fluid');
			$('html').addClass('anthemFluid');
		},

		cleanup: function () {
			$('#alerts').empty().removeClass('multiple').removeAttr('data-alertamt');
			this.alertsView = null;
			//pf.session.cleanup();
		},

		back: function () {
			alert('test');
		},

		notDefined: function () {
			var that = this;
			var RouteModel = require('models/shared/lookups/route');
			var route = new RouteModel();

			var path = Backbone.history.fragment;
			if (typeof path === 'undefined') {
				path = '';
			}

			if (!isEmpty(path)) {
				route.save(
					{ route: path },
					{
						success: function (model, resp) {
							if (!isEmpty(resp)) {
								if (resp.Metadata) {
									var meta = JSON.parse(resp.Metadata);
									pf.session.setRouteMetadata(meta);
								}

								pf.navigate(resp.URL.toLowerCase());
							} else {
								that.showHome();
							}
						},
						error: function (model, resp) {
							switch (resp.status) {
								default:
									that.showHome();
									break;
							}
						},
					}
				);
			} else {
				// console.log('Route not defined',path);
				that.showHome();
			}
		},
	});

	return pf_router;
});

